/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";

@Component({
	selector: "globalictcc-page-not-found",
	standalone: true,
	imports: [],
	templateUrl: "./page-not-found.component.html",
	styleUrl: "./page-not-found.component.scss"
})
export class PageNotFoundComponent {}
